// extracted by mini-css-extract-plugin
module.exports = {"companySign":"CompanySign_companySign__2vNsM"};